var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{class:['ui-notice', { expanded: _vm.expanded }],on:{"click":_vm.toggleExpand}},[_c('div',{staticClass:"ui-notice__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{class:['ui-notice__expand', { expanded: _vm.expanded }]})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }